import styled from 'styled-components'

export const Group = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`

export const Label = styled.label`
	font-size: 16px;
	font-weight: 500;
	margin-bottom: 8px;
	color: ${props => props.theme.colors.text.primaryText};
	text-align: ${props => props.$textAlign || 'left'};
`

export const DatePickerWrapper = styled.div`
	width: 100%;

	.react-datepicker__month-container {
		width: 100%;
	}

	.react-datepicker-wrapper {
		width: 100%;
	}

	.react-datepicker__input-container {
		width: 100%;
		min-width: 0;
	}

	.react-datepicker__input-container > div {
		width: 100%;
	}

	.react-datepicker__input-container > input {
		width: 100%;
		height: ${props => props.theme.sizes.forms.height};
		padding: 10px 16px;
		border: 1px solid ${props => props.theme.colors.greys.defaultBorder};
		border-radius: 8px;
		font-size: 16px;
		color: ${props => props.theme.colors.text.primaryText};
		background-color: ${props => props.theme.colors.brand.white};

		&::placeholder {
			color: ${props => props.theme.colors.greys.disabledGrey};
		}

		&:focus {
			outline: none;
			border-color: ${props => props.theme.colors.brand.blueOmint};
			box-shadow: 0 0 0 2px ${props => props.theme.colors.brand.backgroundBlue};
		}
	}

	.react-datepicker {
		border: 1px solid ${props => props.theme.colors.greys.dividerGray};
		border-radius: 6px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		font-family: inherit;
	}

	.react-datepicker__header {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		border-bottom: 1px solid ${props => props.theme.colors.brand.blueOmint};
	}

	.time-range-calendar .react-datepicker-time__header,
	.time-range-calendar .react-datepicker__header--time {
		color: ${props => props.theme.colors.brand.white} !important;
	}

	.react-datepicker__current-month {
		color: ${props => props.theme.colors.brand.white};
		font-weight: 600;
	}

	.react-datepicker__day-name,
	.react-datepicker__day {
		width: 2.3rem;
		line-height: 2.3rem;
	}

	.react-datepicker__day-name {
		color: ${props => props.theme.colors.brand.white};
	}

	.react-datepicker__day--selected,
	.react-datepicker__day--keyboard-selected,
	.react-datepicker__day--in-selecting-range.react-datepicker__day--range-start,
	.react-datepicker__day--in-selecting-range.react-datepicker__day--range-end,
	.react-datepicker__day--range-start,
	.react-datepicker__day--range-end {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: ${props => props.theme.colors.brand.white};
	}

	.react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):not(.react-datepicker__day--in-range) {
		background-color: transparent;
		color: ${props => props.theme.colors.text.primaryText};
	}

	.react-datepicker__day--range-start,
	.react-datepicker__day--range-end,
	.react-datepicker__day--range-start:hover,
	.react-datepicker__day--range-end:hover,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--range-start,
	.react-datepicker__day--keyboard-selected.react-datepicker__day--range-end,
	.react-datepicker__day--in-selecting-range.react-datepicker__day--range-start,
	.react-datepicker__day--in-selecting-range.react-datepicker__day--range-end {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: ${props => props.theme.colors.brand.white};
	}

	.react-datepicker__day--in-range {
		background-color: ${props => props.theme.colors.brand.backgroundBlue};
		color: ${props => props.theme.colors.text.primaryText};
	}

	.react-datepicker__day:hover {
		background-color: #f0f0f0;
	}

	.react-datepicker__day--selected:hover,
	.react-datepicker__day--in-range:hover {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: ${props => props.theme.colors.brand.white};
	}

	.react-datepicker__day--range-end,
	.react-datepicker__day--range-end.react-datepicker__day--in-range,
	.react-datepicker__day--range-end.react-datepicker__day--keyboard-selected,
	.react-datepicker__day--range-end:hover,
	.react-datepicker__day--range-end.react-datepicker__day--in-range:hover,
	.react-datepicker__day--range-start:active,
	.react-datepicker__day--range-end:active,
	.react-datepicker__day--selecting-range-start,
	.react-datepicker__day--selecting-range-end,
	.react-datepicker__day--selecting-range-start:active,
	.react-datepicker__day--selecting-range-end:active {
		background-color: ${props => props.theme.colors.brand.blueOmint};
		color: ${props => props.theme.colors.brand.white};
	}

	.react-datepicker__day.custom-range-start,
	.react-datepicker__day.custom-range-end,
	.react-datepicker__day.custom-range-start:hover,
	.react-datepicker__day.custom-range-end:hover,
	.react-datepicker__day.custom-range-start:active,
	.react-datepicker__day.custom-range-end:active {
		background-color: ${props => props.theme.colors.brand.blueOmint} !important;
		color: ${props => props.theme.colors.brand.white} !important;
	}

	.react-datepicker__day.custom-in-range,
	.react-datepicker__day.custom-in-range:hover {
		background-color: ${props => props.theme.colors.brand.backgroundBlue} !important;
		color: ${props => props.theme.colors.text.primaryText} !important;
	}

	.react-datepicker__close-icon::after {
		background-color: transparent;
		color: ${props => props.theme.colors.text.primaryText};
		font-size: 18px;
		font-weight: 600;
		height: auto;
		width: auto;
		padding: 0;
	}

	.react-datepicker__close-icon {
		padding: 0 12px 0 0;
	}

	.react-datepicker__close-icon:hover::after,
	.react-datepicker__close-icon:focus::after,
	.react-datepicker__close-icon:active::after {
		background-color: transparent;
		color: ${props => props.theme.colors.text.primaryText};
	}

	.time-range-popper .react-datepicker {
		width: 100%;
	}

	.time-range-calendar.react-datepicker--time-only {
		width: 100%;
		min-width: 0;
	}

	.time-range-calendar .react-datepicker__time-container,
	.time-range-calendar .react-datepicker__time,
	.time-range-calendar .react-datepicker__time-box {
		width: 100% !important;
	}

	.time-range-calendar .react-datepicker__time-list-item {
		white-space: nowrap;
	}

	.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
		padding: 0;
		margin: 0;
	}

	.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		height: 35px;
		padding: 0;
	}

	.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:not(.react-datepicker__time-list-item--selected):hover {
		background-color: #f0f0f0;
		color: ${props => props.theme.colors.text.primaryText};
	}

	.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected,
	.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
		background-color: ${props => props.theme.colors.brand.backgroundBlue};
		color: ${props => props.theme.colors.brand.blueOmint};
	}

	  .react-datepicker-popper{
  		z-index: 9999 !important;
}
`

export const InlineErrorText = styled.div`
	color: ${props => props.theme.colors.feedback.error};
	font-size: 12px;
	margin-top: 4px;
`

export const TimeRangeRow = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;

	> .react-datepicker-wrapper {
		flex: 1;
		min-width: 0;
	}

	.react-datepicker-popper {
		flex: 0 0 auto;
	}

	.time-range-input {
		width: 100% !important;
	}
`